import type { CamelCase } from 'types';

export const toCamelCase = <T extends string>(str: T): CamelCase<T> =>
  str
    ?.replace(/(?:\s|_)(.)/g, $1 => $1.toUpperCase())
    .replace(/\s|_/g, '')
    .replace(/^(.)/, $1 => $1.toLowerCase()) as CamelCase<T>;
